module.exports = __webpack_public_path__ + "static/5-c96458bdf449371c523e5bbe06601bdb.jpg";